<div class="animated fadeIn" [hidden]="!coupons">

    <table-component (onEdit)="onEdit($event)"
                     (onAdd)="onAdd()"
                     (onRemove)="onRemove($event)"></table-component>


    <button type="button" class="btn btn-primary pull-right" id="button_save" (click)="save()">Save</button>
    <br/>
    <br/>
    <br/>

</div>

<kiosk-coupons-edit-component></kiosk-coupons-edit-component>
